import {
  inputClassname,
  placeholderClassname,
  wrapperClassName,
} from 'shared/model/classnames'

import { RenderFormItem } from 'shared/ui/Form/FormItems'

export const keyAccessFields: RenderFormItem[] = [
  {
    type: 'customTextField',
    itemProps: {
      placeholder: 'Логин',
      className: inputClassname,
      wrapperClassname: `${wrapperClassName} pointer-events-none`,
      placeholderClassname: placeholderClassname,
    },
    // formItemProps: {
    //   name: 'login',
    //   rules: [{ required: true, message: requiredText }],
    // },
  },
]
